var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { O as OwnedSchema } from "../../Owned-84ee52ae.js";
import { registerSystem } from "../ComponentRegistry.js";
import { O as OwnerSchema } from "../../Owner-4cb1d33a.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
class OwnedSystem {
  constructor() {
    __publicField(this, "schema", OwnedSchema);
    __publicField(this, "type", "Owned");
  }
  cleanup(entity, gameModel, ejecting) {
    if (ejecting)
      return;
    const owned = gameModel.getTypedUnsafe(entity, OwnedSchema);
    owned.owned.forEach((ownedEntity) => {
      if (!gameModel.isActive(ownedEntity))
        return;
      gameModel.getTypedUnsafe(ownedEntity, OwnerSchema).owner = null;
    });
  }
}
registerSystem(OwnedSystem);
//# sourceMappingURL=Owned.js.map
